import { INDUSTRIES } from "@/content/thoratech";
import { Factory, Sparkles } from "lucide-react";

export default function Industries() {
  return (
    <section
      id="industries"
      data-testid="industries-section"
      className="relative py-24 md:py-32 bg-white border-t border-[#01080E]/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl mb-14">
          <div className="inline-flex items-center gap-3 mb-5">
            <span className="block h-px w-8 bg-[#2AC0A5]" />
            <span className="text-[11px] font-semibold uppercase tracking-[0.22em] text-[#01080E]">
              Industries we serve
            </span>
          </div>
          <h2 className="font-display text-3xl md:text-5xl font-bold leading-[1.05] text-[#01080E]">
            One core domain.
            <br />
            <span className="text-[#2AC0A5]">Built around how industry runs.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-px bg-[#01080E]/10 border border-[#01080E]/10">
          {/* Core domain — featured */}
          <div
            data-testid="industry-core"
            className="lg:col-span-8 bg-[#01080E] text-white p-8 md:p-12 relative overflow-hidden"
          >
            <div aria-hidden className="absolute inset-0 grid-texture-dark opacity-30" />
            <div className="relative">
              <div className="flex items-center gap-3 mb-6">
                <Factory size={22} className="text-[#2AC0A5]" />
                <span className="font-mono-tech text-[10px] uppercase tracking-[0.25em] text-[#7BDCB5]">
                  {INDUSTRIES.primary.label}
                </span>
              </div>
              <h3 className="font-display text-3xl md:text-4xl font-bold leading-tight">
                {INDUSTRIES.primary.title}
              </h3>
              <p className="mt-5 text-[15px] md:text-base text-white/75 max-w-2xl leading-relaxed">
                {INDUSTRIES.primary.detail}
              </p>
              <div className="mt-8 flex flex-wrap gap-2">
                {INDUSTRIES.primary.tags.map((t) => (
                  <span
                    key={t}
                    data-testid={`industry-tag-${t.replace(/\s+/g, "-").toLowerCase()}`}
                    className="font-mono-tech text-[10px] uppercase tracking-[0.2em] text-white/85 border border-white/20 px-3 py-1.5"
                  >
                    {t}
                  </span>
                ))}
              </div>
            </div>
          </div>

          {/* Growing capabilities */}
          <div data-testid="industry-growing" className="lg:col-span-4 bg-white p-8 md:p-10">
            <div className="flex items-center gap-3 mb-4">
              <Sparkles size={20} className="text-[#01080E]" />
              <span className="font-mono-tech text-[10px] uppercase tracking-[0.25em] text-[#01080E]/55">
                {INDUSTRIES.growing.label}
              </span>
            </div>
            <p className="text-sm text-[#01080E]/70 leading-relaxed mb-5">
              {INDUSTRIES.growing.detail}
            </p>
            <ul className="space-y-2.5">
              {INDUSTRIES.growing.items.map((it) => (
                <li
                  key={it}
                  className="flex items-start gap-3 text-sm text-[#01080E]/85"
                >
                  <span aria-hidden className="mt-2 inline-block h-1.5 w-1.5 bg-[#2AC0A5]" />
                  {it}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <p className="mt-6 text-xs text-[#01080E]/55 italic max-w-2xl">{INDUSTRIES.disclaimer}</p>
      </div>
    </section>
  );
}
